import { useNavigate } from "react-router";

interface Props {
  key: string;
  index: number;
  name: string;
  img: string;
  navigateTo: string;
}
export const PortfolioImgTile = ({
  key,
  index,
  name,
  img,
  navigateTo
}: Props) => {
  const navigate = useNavigate();
  return (
    <div key={key} className="mb-10 flex w-1/3 flex-col p-4">
      <div
        onClick={() => {
          navigate(navigateTo);
        }}
        className={`flex max-w-96 cursor-pointer flex-col hover:opacity-75 ${index === 0 || !!(index && !(index % 3)) ? "ml-auto" : index && !((index + 1) % 3) ? "mr-auto" : "mx-auto"}`}
      >
        <span className="mx-auto mb-2 block whitespace-nowrap text-xl font-bold">
          {name}
        </span>
        <img
          src={img}
          alt="logo"
          className="rounded border-2 border-cream-700 p-0.5"
        />
      </div>
    </div>
  );
};
